import { useEffect, useState } from 'react'
import { BILLS_TAGS, FIREBASE_EVENTS, GET_PAYMENT_URL_ERROR_MESSAGE } from 'app-constants'
import { formatCurrency, formatDate, isValidPaymentRecurring, getTagInfo } from 'utils'
import { useToaster } from 'hooks'
import { RecurringPayment } from '../recurring-payment'
import { InvoiceTag } from '../invoice-tag'
import { PaymentButton } from '../payment-button'
import { EmptyBills } from '../empty-bills'
import { BillsDownload } from '../bills-download'
import './style.scss'

export function BillDetails({ selectedContractId, bankSlips }) {
  const [selectedBankSlip, setSelectedBankSlip] = useState(null)
  const { id, value, dueDate, tags, isPaymentRecurring, paymentType, detailedInvoiceUrl } =
    selectedBankSlip || {}
  const { showErrorToast } = useToaster()

  useEffect(() => {
    function resolvePayment() {
      const negotiatedSlip = bankSlips.content.find(
        ({ contractId, tags: slipTags = [] }) =>
          contractId === selectedContractId && slipTags.includes(BILLS_TAGS.BREACH_OF_AGREEMENT)
      )
      const firstBankSlip = bankSlips.content.find(
        ({ contractId, tags: slipTags = [] }) =>
          contractId === selectedContractId && !slipTags.includes(BILLS_TAGS.IN_NEGOTIATION)
      )
      const pendingPayment = negotiatedSlip || firstBankSlip
      setSelectedBankSlip(pendingPayment)
    }

    if (selectedContractId) resolvePayment()
  }, [bankSlips.content, selectedContractId])

  function handleGetPaymentLinkErroMessage(error) {
    const errorMessage = error || GET_PAYMENT_URL_ERROR_MESSAGE

    showErrorToast(errorMessage)
  }

  function isActivePaymentRecurring() {
    return isValidPaymentRecurring(isPaymentRecurring, paymentType, dueDate)
  }

  function renderPaymentOptions() {
    if (isActivePaymentRecurring()) return <RecurringPayment />

    return (
      <PaymentButton
        showErrorMessage={handleGetPaymentLinkErroMessage}
        invoiceId={id}
        event={FIREBASE_EVENTS.CLICK_ON_PAYMENT_DASHBOARD}
      />
    )
  }

  function renderPaymentDetails() {
    if (!selectedBankSlip) {
      return <EmptyBills billType='Não existem faturas abertas para este contrato' />
    }

    const tagInfo = getTagInfo(false, isPaymentRecurring, tags, paymentType, dueDate)

    return (
      <div className='bill-info-content'>
        <div className='container-info'>
          <div className='container-infos-holder'>
            <span className='number'>N.º {id}</span>
            <div className='container-value'>
              <span className='label'>Valor: </span>
              <span className='value'>{formatCurrency(value)}</span>
            </div>
          </div>
          <div className='container-infos-holder'>
            <div className='container-due-date'>
              <span className='label'>Vencimento:</span>
              <span className='value'>{formatDate(dueDate)}</span>
            </div>
            <div className='container-tag'>
              <span className='label'>Status:</span>
              <InvoiceTag className='tag' tagInfo={tagInfo} />
              <BillsDownload tags={tags} url={detailedInvoiceUrl} />
            </div>
          </div>
        </div>
        <div className={`container-actions ${isActivePaymentRecurring() ? '' : 'payment'}`}>
          {renderPaymentOptions()}
        </div>
      </div>
    )
  }

  function renderContent() {
    if (bankSlips.error) return <EmptyBills billType='Falha ao consultar faturas' />

    if (bankSlips.isLoading) return <div className='bill-info-loading' />

    if (!bankSlips.content) return null

    return renderPaymentDetails()
  }

  return <div className='bill-info-container'>{renderContent()}</div>
}
